var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconFlatNew = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F1F19",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M2.75 21.25h18.5M17 21V4.735C17 3.777 16.223 3 15.265 3h-3.53C10.777 3 10 3.777 10 4.735V21"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F1F19",
  strokeLinecap: "round",
  d: "M13.5 6.5v-1m0 4v-1m0 4v-1m0 4v-1m0 4v-1"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  stroke: "#2F1F19",
  strokeWidth: 1.5,
  d: "M20.266 11.75h-3.532a.985.985 0 0 0-.984.984v7.532c0 .543.44.984.984.984h3.532c.543 0 .984-.44.984-.984v-7.532a.985.985 0 0 0-.984-.984ZM10 8.75H5c-.69 0-1.25.56-1.25 1.25v10.266c0 .543.44.984.984.984h5.532c.543 0 .984-.44.984-.984V10c0-.69-.56-1.25-1.25-1.25Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F1F19",
  strokeLinecap: "round",
  d: "M18 15h1M6.5 12h2m9.5 6h1M6.5 15h2m-2 3h2"
})));
export default SvgIconFlatNew;